import { Component, OnInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { skipWhile, take, tap } from 'rxjs/operators';
import moment from 'moment';
import 'moment-timezone';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';
import { AwayADActionBLL } from './away-ad-actions.bll';
import { FieldSchedulesBLL } from '../field-schedules.bll';
import { FieldFacilityBLL } from '../../field-facility/field-facility.bll';
import { BusContactsBLL } from '../../bus-contacts/bus-contacts.bll';
import { ADContactsBLL } from '../../ad-contacts/ad-contacts.bll';
import { RefereeContactsBLL } from '../../referee-contacts/referee-contacts.bll';
import { LeaguesBLL } from 'src/app/views/leagues/leagues.bll';
import { create_event } from './model';

@Component({
  selector: 'app-away-ad-actions',
  templateUrl: './away-ad-actions.page.html',
  styleUrls: ['./away-ad-actions.page.scss'],
})
export class AwayAdActionsPage implements OnInit {

  isOpenEarlyTime: boolean = false;

  referee_contacts$: Observable<any>;
  bus_contacts$: Observable<any>;

  show_addNew$: Observable<boolean>;

  field_facilities$: Observable<any>;

  edit_field_event_overlay: boolean = false;

  send_updates_to_referees?: boolean = false;
  send_updates_to_bus_service?: boolean = false;

  //Loaders
  isLoading$: Observable<boolean>;

  form: FormGroup
  enable_notifications: boolean = true;

  selected_schedule: any = null;

  date_picker: string = moment(new Date()).format('YYYY-MM-DD');

  start_time_picker: string = moment().format('YYYY-MM-DDTHH:mm');
  early_time_picker: string = null;
  report_time_picker: string = null;

  departure_time_picker: string = moment(this.start_time_picker).add(1, 'hour').format('YYYY-MM-DDTHH:mm');
  return_time_picker: string = moment(this.start_time_picker).add(3, 'hour').format('YYYY-MM-DDTHH:mm');

  // League schedule attachment (mirrors the field activity modal)
  leagues$: Observable<any>;
  leaguesLoading$: Observable<boolean>;
  league_schedules$: Observable<any>;
  show_league: boolean = false;
  selected_league: any = null;
  // Set while the pre-select runs. In Ionic 6 ion-select emits (ionChange) for programmatic
  // value changes too, and handleLeagueChange resets the schedule — which would wipe the
  // very value being pre-selected.
  populating_league: boolean = false;

  // schoolsSubscription: Subscription;
  fieldsSubscription: Subscription;
  busContactsSubscription: Subscription;

  customSportAlertFacilityOptions = {
    header: 'Select Facility Field',
    message: 'Select One',
    translucent: true,
  };

  customSportAlertBusServiceOptions = {
    header: 'Select Bus Service',
    message: 'Select One',
    translucent: true,
  };

  customAlertRefereeOptions = {
    header: 'Select Referee',
    message: 'Select One',
    translucent: true,
  };

  customAlertLeagueOptions = {
    header: 'Select League',
    message: 'Select One',
    translucent: true,
  };

  customAlertLeagueScheduleOptions = {
    header: 'Select League Schedule',
    message: 'Select One',
    translucent: true,
  };


  constructor(
    private bll: AwayADActionBLL,
    private fb: FormBuilder,
    private toast: ToastController,
    private fieldSchedulesBLL: FieldSchedulesBLL,
    private fieldFacilityBLL: FieldFacilityBLL,
    private busContactsBLL: BusContactsBLL,
    private adContactsBll: ADContactsBLL,
    private refereeContactBll: RefereeContactsBLL,
    private leaguesBLL: LeaguesBLL
  ) {
    this.form = this.fb.group(this.initialize_form());

    // For Add New

    this.fieldFacilityBLL.selectedFacility$
      .pipe(skipWhile(val => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_facilities(id);
        }
      });

    this.bll.selectedFacility$
      .pipe(skipWhile(val => !val))
      .subscribe((facility) => {
        if (facility.id) {
          this.field_facility.setValue(facility);
        }
      });


    this.busContactsBLL.selectedBuses$
      .pipe(skipWhile(val => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_bus_contacts(id);
        }
      });

    this.bll.selectedBuses$
      .pipe(skipWhile(val => !val))
      .subscribe((contact) => {
        this.bus_email.setValue(contact.email);
        this.bus_cell.setValue(contact.number);
        this.bus_service.setValue(contact);
      });

    this.refereeContactBll.selectedReferees$
      .pipe(skipWhile(val => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_referee_contacts(id);
        }
      });

    this.bll.selectedReferee$
      .pipe(skipWhile((val) => !val))
      .subscribe((contact) => {
        this.selectedReferees.push(contact);
      });
  }

  ngOnInit() {
    this.mapObservables();
    this.fieldSchedulesBLL.selectedSchedule$.subscribe(schedule => {

      if (schedule) {
        this.selected_schedule = schedule;
        // This AD's own assigned leagues — the list to attach from
        this.bll.get_assigned_leagues();
        this.fieldsSubscription = this.bll.field_facilities$.subscribe(fields => {
          if (schedule.opposing_ad_field_id) {
            let s_field = fields.filter(f => f.id == schedule.opposing_ad_field_id)[0];
            this.field_facility.setValue(s_field);
          }
        });

        this.busContactsSubscription = this.bll.bus_contacts$.subscribe(bc => {
          if (schedule.opposing_ad_bus_contact_id) {
            let bus_service = bc.filter(f => f.id == schedule.opposing_ad_bus_contact_id)[0];
            this.bus_service.setValue(bus_service);
          }
        });

        if (schedule?.date_of_game_event) {
          const date = moment(schedule?.date_of_game_event).format('YYYY-MM-DD');
          this.date_picker = date;
          const early = schedule?.opposing_team_early_time;
          const report_time = schedule?.opposing_team_report_time;
          const departure = schedule?.opposing_team_departure;
          const return_time = schedule?.opposing_team_return_time;


          // Early Time
          if (early) {
            let eh = moment(early).format('HH');
            let em = moment(early).format('mm');
            let current_early = `${date}T${eh}:${em}`;
            const earlyMoment = moment(current_early);
            this.early.setValue(earlyMoment.toDate());
            this.early_time_picker = earlyMoment.format('YYYY-MM-DDTHH:mm');
          }

          if (report_time) {
            let rh = moment(report_time).format('HH');
            let rm = moment(report_time).format('mm');
            let current_report_time = `${date}T${rh}:${rm}`;
            const reportMoment = moment(current_report_time);
            this.report_time.setValue(reportMoment.toDate());
            this.report_time_picker = reportMoment.format('YYYY-MM-DDTHH:mm');
          }

          // Departure Time
          if (departure) {
            let dh = moment(departure).format('HH');
            let dm = moment(departure).format('mm');
            let current_dep = `${date}T${dh}:${dm}`;
            const departureMoment = moment(current_dep);
            this.departure.setValue(departureMoment.toDate());
            this.departure_time_picker = departureMoment.format('YYYY-MM-DDTHH:mm');
          }

          //  Return Time
          if (return_time) {
            let rh = moment(return_time).format('HH');
            let rm = moment(return_time).format('mm');
            let current_return = `${date}T${rh}:${rm}`;
            const returnMoment = moment(current_return);
            this.return_time.setValue(returnMoment.toDate());
            this.return_time_picker = returnMoment.format('YYYY-MM-DDTHH:mm');
          }

          this.date_picker = date;
          // this.updateTimeOptions();
        }

        if (this.selected_schedule?.id) {
          this.populateForm(schedule);
        }

      }
    });
  }

  selectEarlyTime() {
    this.isOpenEarlyTime = true;
  }

  isOpenReportTime = false;

  selectReportTime() {
    this.isOpenReportTime = true;
  }

  onEarlyTimePopoverClose() {
    this.isOpenEarlyTime = false;
  }

  onReportTimePopoverClose() {
    this.isOpenReportTime = false;
  }

  mapObservables() {
    this.referee_contacts$ = this.bll.referee_contacts$;
    this.field_facilities$ = this.bll.field_facilities$;
    this.bus_contacts$ = this.bll.bus_contacts$;
    this.show_addNew$ = this.bll.show_addMenu$;
    this.isLoading$ = this.bll.isLoading$;
    this.leagues$ = this.bll.leagues$;
    this.leaguesLoading$ = this.bll.leaguesLoading$;
    this.league_schedules$ = this.leaguesBLL.schedulerData$;
  }


  time_change(type: string, event: any) {

    if (!event.detail.value) {
      return;
    }

    const applyTime = (control: any) => {
      let h = moment(event.detail.value).format('HH');
      let m = moment(event.detail.value).format('mm');
      let current_d = moment(this.date_picker ? this.date_picker : this.start.value).format('YYYY-MM-DD');
      current_d = `${current_d}T${h}:${m}`;
      control.setValue(moment(current_d).toDate());
      return moment(current_d);
    };

    switch (type) {

      case 'early':
        const earlyMoment = applyTime(this.early);
        this.early_time_picker = earlyMoment.format('YYYY-MM-DDTHH:mm');
        break;

      case 'report_time':
        const reportMoment = applyTime(this.report_time);
        this.report_time_picker = reportMoment.format('YYYY-MM-DDTHH:mm');
        break;

      case 'departure':
        const departureMoment = applyTime(this.departure);
        this.departure_time_picker = departureMoment.format('YYYY-MM-DDTHH:mm');
        break;

      case 'return_time':
        const returnMoment = applyTime(this.return_time);
        this.return_time_picker = returnMoment.format('YYYY-MM-DDTHH:mm');
        break;
    }

  }

  reset_form_and_bll() {
    this.show_league = false;
    this.selected_league = null;
    this.populating_league = false;
    this.fieldSchedulesBLL.selectedSchedule$.next(null);
    this.bll.reset_teams_observable();
    this.bll.reset_event_created();
    this.form = this.fb.group(this.initialize_form());
    this.date_picker = moment(new Date()).format('YYYY-MM-DD');
    this.start_time_picker = moment().format('YYYY-MM-DDTHH:mm');
    this.early_time_picker = null;
    this.report_time_picker = null;
    this.early.setValue(null);
    this.report_time.setValue(null);
    this.selected_schedule = null;
    this.selectedReferees = [];
    this.send_updates_to_referees = false;
    this.send_updates_to_bus_service = false;

    this.fieldSchedulesBLL.reset_sessions();

    if (this.fieldsSubscription) {
      this.fieldsSubscription.unsubscribe();
      this.fieldsSubscription = null;
    }

    if (this.busContactsSubscription) {
      this.busContactsSubscription.unsubscribe();
      this.busContactsSubscription = null;
    }

  }


  populateForm(eventData: any) {
    this.selectedReferees = eventData.opposing_ad_referee_contacts;
    this.fees_referee?.setValue(eventData.fee_per_referee || null);
    this.bus_email?.setValue(eventData.opposing_bus_email || '');
    this.bus_cell.setValue(eventData.opposing_bus_mobile || '');
    this.buses_needed.setValue(eventData.opposing_team_buses_needed || 0);

    if (eventData.opposing_ad_referee_contacts?.length > 0) {
      this.form.get('need_referees_assigned')?.setValue(true);
    }

    this.form.get('bus')?.setValue(!!eventData.opposing_team_need_bus);

    this.populateLeague(eventData);
  }

  // Pre-selects the league + league schedule already attached to this event
  populateLeague(eventData: any) {
    const leagueId = eventData?.league_id || null;
    const leagueScheduleId = eventData?.league_scheduler_id || null;

    if (!leagueId) {
      return;
    }

    this.show_league = true;
    this.populating_league = true;

    // Both ids come straight off the row, so the controls are filled right away instead of
    // waiting on a request. ion-select keeps a value whose option has not loaded yet and
    // re-renders its label once the options show up (see its watchForOptions callback),
    // so nothing here needs to be sequenced behind the two fetches.
    this.league_id.setValue(leagueId);
    this.league_schedule_id.setValue(leagueScheduleId);
    this.form.get('league_id').setValidators([Validators.required]);
    this.form.get('league_id').updateValueAndValidity();
    this.form.get('league_schedule_id').setValidators([Validators.required]);
    this.form.get('league_schedule_id').updateValueAndValidity();

    // Options for the schedule picker. Fired here rather than left to handleLeagueChange,
    // which the guard suppresses for the programmatic (ionChange) above.
    this.leaguesBLL.getAllLeagueScheduler(leagueId);

    // Released once those programmatic (ionChange)s have been delivered, so a later AD
    // pick is handled normally
    setTimeout(() => {
      this.populating_league = false;
    });

    // Only feeds the read-only year/season display, so it can fill in whenever it lands
    this.leagues$
      .pipe(
        skipWhile((leagues) => !leagues || leagues.length === 0),
        take(1),
      )
      .subscribe((leagues) => {
        this.selected_league = leagues?.find((l: any) => l.league_id === leagueId) || null;
      });
  }

  initialize_form() {
    return {
      referee: [null],
      field_facility: [''],
      field_address: [''],
      need_referees_assigned: [false],
      ref_org_name: [''],
      Ref_Org_email: [''],
      Ref_Org_mobile: [''],
      fees_referee: ['', [Validators.required]],
      bus: [false],
      bus_service: [null],
      bus_email: [''],
      bus_cell: [''],
      buses_needed: [0],
      start: [moment(new Date()).toDate()],
      early: [null],
      report_time: [null],
      departure: [moment(new Date()).add(1, 'hour').toDate()],
      return_time: [moment(new Date()).add(1, 'hour').toDate()],
      league_id: [null],
      league_schedule_id: [null],
    }
  }

  close_add_menu() {
    this.reset_form_and_bll();
    this.bll.toggle_add_menu(false);
    this.show_league = false;
    this.selected_league = null;
  }

  handleLeagueChange(event: any) {
    // Ignore the (ionChange) the pre-select itself causes; only real AD picks reset things
    if (this.populating_league) {
      return;
    }

    const leagueId = event.detail.value;
    this.form.get('league_schedule_id').reset();
    if (leagueId) {
      this.form.get('league_schedule_id').setValidators([Validators.required]);
      this.leaguesBLL.getAllLeagueScheduler(leagueId);
      this.leagues$.pipe(take(1)).subscribe((leagues) => {
        this.selected_league = leagues?.find((l: any) => l.league_id === leagueId) || null;
      });
    } else {
      this.form.get('league_schedule_id').clearValidators();
      this.selected_league = null;
    }
    this.form.get('league_schedule_id').updateValueAndValidity();
  }

  clearLeague() {
    this.form.get('league_id').reset();
    this.form.get('league_id').clearValidators();
    this.form.get('league_schedule_id').reset();
    this.form.get('league_schedule_id').clearValidators();
    this.form.get('league_schedule_id').updateValueAndValidity();
    this.selected_league = null;
  }

  onShowLeagueChange(event: any) {
    // An explicit AD toggle always ends the pre-select, so the guard can never stick
    this.populating_league = false;
    this.show_league = (event.target as HTMLInputElement).checked;
    if (!this.show_league) {
      this.clearLeague();
    }
  }

  get league_id() {
    return this.form.get('league_id');
  }

  get league_schedule_id() {
    return this.form.get('league_schedule_id');
  }

  toggle_notification() {
    this.enable_notifications = !this.enable_notifications;
  }

  date_change(event: any) {
    let date_value = moment(event.target.value).format('YYYY-MM-DD');
    this.date_picker = date_value;
  }

  open_edit_field_event_overlay() {
    this.edit_field_event_overlay = true;
  }

  async create_event() {

    let data = this.form.value;

    let message = '';

    if (data.need_referees_assigned && this.selectedReferees?.length < 1) {
      message = 'Please select Select at least one referee.';
      this.edit_field_event_overlay = false;
    } else if (data.need_referees_assigned && !data.fees_referee) {
      message = 'Referee Fee is required.';
      this.edit_field_event_overlay = false;
    } else if (this.bus.value && !data.bus_service?.id) {
      message = 'Please select a Bus Service.';
      this.edit_field_event_overlay = false;
    } else if (data.league_id && !data.league_schedule_id) {
      message = 'Please select a League Schedule.';
      this.edit_field_event_overlay = false;
    }

    if (message) {
      const toast = await this.toast.create({
        message: message,
        buttons: [{
          role: 'cancel',
          text: 'Ok'
        }],
        duration: 3000,
        color: 'danger',
        position: 'bottom'
      });
      await toast.present();
      return;
    }

    // let time_checker_start = moment(this.start.value).format('YYYY-MM-DDTHH:mm:ssZ');
    // let time_checker_end = moment(this.end.value).format('YYYY-MM-DDTHH:mm:ssZ');
    let early_time_picker = this.early.value ? moment(this.early.value).format('YYYY-MM-DDTHH:mm:ssZ') : null;
    let report_time_picker = this.report_time.value ? moment(this.report_time.value).format('YYYY-MM-DDTHH:mm:ssZ') : null;
    let departure_time_picker = moment(this.departure.value).format('YYYY-MM-DDTHH:mm:ssZ');
    let return_time_picker = moment(this.return_time.value).format('YYYY-MM-DDTHH:mm:ssZ');

    let d = moment(this.date_picker).format('YYYY-MM-DD');
    // let h = moment(new Date()).format('HH');
    // let m = moment(new Date()).format('mm');
    let current = `${d}T12:00`;
    const date_with_time_to_save = moment(current).format('YYYY-MM-DDTHH:mm:ssZ');

    const ids = this.selectedReferees?.map(item => item.id);
    const emails = this.selectedReferees?.map(item => item.email);
    let origin = window.location.origin;

    let field_event: create_event = {

      early_time: early_time_picker,
      report_time: report_time_picker,
      departure: data.bus ? departure_time_picker : null,
      return_time: data.bus ? return_time_picker : null,
      // bus_service_id: data.bus_service?.id,
      buses_needed: data.buses_needed,
      need_game_contract: data.need_game_contract,
      need_referees_assigned: data.need_referees_assigned,
      fee_per_referee: data.fees_referee ? data.fees_referee : null,
      need_bus: data.bus,
      field_id: data.field_facility?.id,
      // field_name: data.field_facility?.label,
      // referee_contact_ids: ids,
      // referee_contact_emails: emails,
      referees: this.selectedReferees,
      bus_service: data.bus_service,
      id: this.selected_schedule?.id,
      send_updates_to_referees: this.send_updates_to_referees,
      send_updates_to_bus_service: this.send_updates_to_bus_service,

      origin: origin,
      start_time: moment(this.start.value).format('YYYY-MM-DDTHH:mm:ssZ'),
      date_of_game_event: date_with_time_to_save,
      game_type: this.selected_schedule?.game_type || 'away',
      club_name: this.selected_schedule?.club_name || '',
      your_team_title: this.selected_schedule?.assign_team_title || '',
      opposing_team_name: this.selected_schedule?.opposing_team_name || '',
      sport_name: this.selected_schedule?.sport_name || ''
    };

    // Stored on this AD's own opposing_ad_assigned_field_data row, so it is always sent:
    // it can only ever affect their attachment, and null is how they detach one.
    field_event.league_scheduler_id = this.show_league ? data.league_schedule_id || null : null;

    this.bll.update_field_event(field_event);


    this.reset_form_and_bll();
    this.edit_field_event_overlay = false;

  }

  get start() {
    return this.form.get('start');
  }

  get early() {
    return this.form.get('early');
  }

  get report_time() {
    return this.form.get('report_time');
  }

  get departure() {
    return this.form.get('departure');
  }

  get return_time() {
    return this.form.get('return_time');
  }


  field_id: string;

  get field_facility() {
    return this.form.get('field_facility');
  }

  get bus_service() {
    return this.form.get('bus_service');
  }

  get bus_email() {
    return this.form.get('bus_email');
  }

  get bus() {
    return this.form.get('bus');
  }

  get bus_cell() {
    return this.form.get('bus_cell');
  }

  get buses_needed() {
    return this.form.get('buses_needed');
  }

  get ad_cell() {
    return this.form.get('ad_cell');
  }

  get ref_org_name() {
    return this.form.get('ref_org_name');
  }

  get Ref_Org_email() {
    return this.form.get('Ref_Org_email');
  }

  get Ref_Org_mobile() {
    return this.form.get('Ref_Org_mobile');
  }

  get fees_referee() {
    return this.form.get('fees_referee');
  }

  get referee() {
    return this.form.get('referee');
  }

  handleFacilityFieldChange(e) {
    this.field_id = e.detail.value;
  }

  club_id: string;

  handleChangeSchool(e) {
  }

  handleChangeBusService(e) {
    this.bus_email.setValue(e.detail.value.email);
    this.bus_cell.setValue(e.detail.value.number);
    this.buses_needed.setValue(1);
  }

  selectedReferees = [];

  async handleChangeReferee(e) {
    const value = e.detail.value;

    if (value) {
      if (this.selectedReferees.includes(value)) {
        const t = await this.toast.create({
          message: `Referee already selected.`,
          duration: 5000,
          color: 'warning'
        });
        await t.present();
      } else {
        value.refs_needed = 1;
        this.selectedReferees.push(e.detail.value);
        this.customAlertRefereeOptions.message = 'Add More Referee?'
      }
    }

    this.referee.setValue(null);
  }

  removeReferee(index: any): void {
    this.selectedReferees.splice(index, 1);
  }

  stringifySchools(sch) {
    return JSON.stringify(sch);
  }

  openAddFacilityFieldModal() {
    this.fieldFacilityBLL.toggleAddFacilityModel(true);
  }

  openAddBusContactModal() {
    this.busContactsBLL.toggleAddContactModel(true);
  }

  openADContactModal() {
    this.adContactsBll.toggleAddContactModel(true);
  }

  openRefereeContactModal() {
    this.refereeContactBll.toggleAddContactModel(true);
  }

}
